import { render, staticRenderFns } from "./WorkshopsImportingView.vue?vue&type=template&id=c15a3652&scoped=true&"
import script from "./WorkshopsImportingView.vue?vue&type=script&lang=ts&"
export * from "./WorkshopsImportingView.vue?vue&type=script&lang=ts&"
import style0 from "./WorkshopsImportingView.vue?vue&type=style&index=0&id=c15a3652&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15a3652",
  null
  
)

export default component.exports